export default `---
slug: apziva-bootcamp
type: extracurricular
dateRange: "Spring 2023 – Fall 2023"
institution: "Apziva"
location: "Remote"
role: "Data Science Program Participant"
current: false
sortKey: "2024-12"
skills: [Python, Machine Learning, XGBoost, NLP, Computer Vision, Time Series, Reinforcement Learning, Deep Learning]
relatedLinks:
  - label: "Happy Customers"
    href: /projects/happy-customers
  - label: "Sales Reinforcer"
    href: /projects/sales-reinforcer
  - label: "LLM Fine-tuning"
    href: /projects/llm-finetuning
---

In spring 2023, I started the Apziva Data Science program — a 6-month bootcamp focused on applied data science with real datasets and weekly mentor sessions. I completed seven projects spanning the full breadth of ML: binary classification, imbalanced datasets, NLP with word2vec and TF-IDF, computer vision with CNNs, time series forecasting with ARIMA, audio generation and detection, and Reinforcement Learning with Q-learning. Each project came with a dataset, a mentor (shout out to Bhargav), and the expectation to work independently. All projects are documented in detail in the Projects section.

The bootcamp was a turning point: it gave me structured exposure to a wide range of ML techniques and, crucially, the confidence to call myself a practitioner rather than just an enthusiast.
`;
